import React, { useState, useEffect } from "react";
import apiService from "./services/api.service";
import ImageGallery from "./imageGallery";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { addItem, removeItem, resetCart } from "./Redux/shoppingCartReducer";
import "./i18n/config";
import i18next from "i18next";
import { Row, Col, InputGroup, Button } from "react-bootstrap";
import NumberFormat from 'react-number-format';
import StorageSessionService from "./services/storage.service";
import CompanyProductComponent from "./companyComponents/CompanyProduct";
import store from './Redux/store.js'
import { ProductType } from "./data/enums";
import { eventService } from "./services/event.service.js";

function CurrentProductComponent(props) {
  const [product, setProduct] = useState([null]);
  const [lang, setLang] = useState("");

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const itemsFromRedux = useSelector((state) => state.cart.items);
  const productsFromSession = window.sessionStorage.getItem("products");
  const items = productsFromSession ? JSON.parse(productsFromSession) : itemsFromRedux;
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  const propertyId = new URLSearchParams(location.search).get("propid") || 0;
  const LastfreePriceChosenKey = 'LastfreePriceChosen';
  const sessionService = new StorageSessionService();
  const companyUser = useSelector((state) => state.company.companyUser)
  const company = useSelector((state) => state.company.company)

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };


  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");
   

    getProducts();    
    if (window.parent === window.self) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      console.info("Prod page window.parent === window.self");
    } else {
      console.info('dispatch event to scroll!');
      window.parent.postMessage({ toScroll: true }, '*');
    }
  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  const getCurrentItemCount = () => {
    if (product && items) {
      for (let key of Object.keys(items)) {
        if (key === String(product.productId)) {
          return items[product.productId].qty;
        }
      }
    }
    return 0;
  }
  const getProductsFromApi = () => {
    const selectedProductId = new URLSearchParams(location.search).get("pid") || 0;
    let _properyId = null;
    if (companyUser && company) {
      apiService.getCompanyProducts(company.companyId, selectedProductId).then(
        (response) => {
          if(response.data && response.data.data){
            setProduct(response.data.data[0]);
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          if (_content.indexOf("401") > -1) {
            sessionStorage.removeItem("token");
          }
        }
      )
    } else {
      apiService.getProducts(chainId, _properyId, true, selectedProductId).then(
        (response) => {
        
          if(response.data && response.data.data){
            setProduct(response.data.data[0]);
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          if (_content.indexOf("401") > -1) {
            localStorage.removeItem("token");            
          }
        }
      )
    }
  }
  const getProducts = () => {    
    if(sessionStorage.getItem("viewProduct")){
      let product = JSON.parse(sessionStorage.getItem("viewProduct"));
      setProduct(product);

      sessionService.getSessionStorage(LastfreePriceChosenKey).then(res => {
        let lastLastfreePriceChosen = res || null;
        if (lastLastfreePriceChosen) {
          product.productPrice = parseInt(lastLastfreePriceChosen);
          if (!product.productPrice && product.productMaximumPrice > 0 && (product.productMaximumPrice == product.productMinimumPrice)) {
            product.productPrice = product.productMaximumPrice
          }
        }          
      });
      eventService.viewItem(product);
    }else{
      //fetch from api
      getProductsFromApi();
    }
  };

  const addItemToCart = () => {
    dispatch(resetCart())
    dispatch(addItem({ selectedProduct: product }));
    insertNewSearch(product);
    if (product.productTypeId != ProductType.Goods) {
      blockProduct(1);
    }
  };

  const gotoReg = () => {
    if (getCurrentItemCount() > 0) {
      blockProduct(getCurrentItemCount());
    }
  }

  const blockProduct = (amount) => {
    sessionStorage.removeItem('productBlockingIdentifier');
    apiService.blockProduct(product.productId, amount).then(
      (response) => {
        let productBlockingIdentifier = response.data;
        if (productBlockingIdentifier) {
          sessionStorage.setItem('productBlockingIdentifier', productBlockingIdentifier);
          sessionStorage.setItem('productBlockingIdentifierTime', new Date().toISOString());
          history.push(`/registrastion?chainid=${chainId}&lang=${lang}`);
          
          eventService.addToCart();
        }
        else {
          alert(t("prodNotAvail"));
        }
      },
      (error) => {
        alert(t("prodNotAvail"));
      }
    );
  }

  const insertNewSearch = (prod) => {
    apiService.insertSearch(prod.productId, null, null, null, true, new Date().toISOString());
    sessionStorage.removeItem('lastOrderNum');
    sessionStorage.removeItem('lastCustomer');
    sessionStorage.removeItem('payerName');
  }

  const getProductTranslations = (prod) => {
    if (prod && prod.translations) {
      let ProductTranslations = prod.translations.filter((p) => {
        return p.languageIsoCode == lang && p.propductId == prod.propductId;
      });
      return ProductTranslations.length > 0 ? ProductTranslations[0] : {};
    }
    return {};
  };

  // const unblockProduct = (productBlockingIdentifier) => {
  //   sessionStorage.removeItem('productBlockingIdentifier');
  //   sessionStorage.removeItem('productBlockingIdentifierTime');


  //   apiService.unblockProduct(productBlockingIdentifier).then(
  //     (response) => {

  //     },
  //     (error) => {

  //     }
  //   );

  // };

  return (
    <>
      {!companyUser ?
        <div className="product-wrap">
          <Row>
            <Col>
              {!!product && (
                <div className="product box">

                  <div className="top-line">
                    <Col className="name" role="heading" aria-label={getProductTranslations(product).productName ? getProductTranslations(product).productName : product.productName} dangerouslySetInnerHTML={{ __html: getProductTranslations(product).productName ? getProductTranslations(product).productName : product.productName }}></Col>
                    <Col className="price hidden-mobile">

                      <NumberFormat className="prod-prc" role="application" aria-roledescription={t("price")} aria-label={(product.productPrice) + (product.currencyCode
                        ? product.currencyCode.replace("ILS", "₪")
                        : product.currencyCode)} value={product.productPrice} displayType={'text'} thousandSeparator={true} prefix={product.currencyCode
                          ? product.currencyCode.replace("ILS", "₪")
                          : product.currencyCode} />
                      <button aria-label={t("book")} className="btn long" onClick={(e) => addItemToCart(product)}>{t("book")} </button>

                    </Col>
                  </div>
                  <Row>
                    <Col sm={12} md={6} className="shop-item">
                      <ImageGallery product={product || null} images={product.images || []} />
                      <div className="float-price hidden-desk">
                        <NumberFormat value={product.productPrice} displayType={'text'} thousandSeparator={true} prefix={product.currencyCode
                          ? product.currencyCode.replace("ILS", "₪")
                          : product.currencyCode} />
                      </div>
                    </Col>
                    <Col sm={12} md={6} >
                      <div className="descr-wrap">
                        <div className="descr" dangerouslySetInnerHTML={{ __html: getProductTranslations(product)?.productDescription }}></div>
                        <div className="bottom-sec">
                          <div className="btns-wrap">
                            <Row className="stick-btns">
                              <Col sm={12} md={6} > <Link aria-label={t("backToProductsList")} className="btn white" to={`/?chainid=${chainId}&lang=${lang}`} >{t("backToProductsList")}</Link></Col>
                              {product.productTypeId != ProductType.Goods ?
                                <Col sm={12} md={6} className="book-btn"><button aria-label={t("book")} className="btn long" onClick={(e) => addItemToCart(product)}>{t("book")} </button></Col> :
                                <Col sm={12} md={6} className="book-btn"><button aria-label={t("book")} className="btn long" onClick={(e) => gotoReg()}>{t("book")} </button></Col>
                              }
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Col>
          </Row>
        </div>
        :
        <div className="product-wrap">
          <div className="product box">
            <CompanyProductComponent />
          </div>
        </div>
      }
    </>
  )
}

export default CurrentProductComponent;
